// Prerender the topic index — content rarely changes and it's SEO-critical.
export const prerender = true;
